import colors from './colors';

export default {
  dark: false,
  colors: {
    'surface-secondary': colors.gray.light0,
    'surface-primary': colors.gray.light0,
    'surface-overlay': colors.alpha.dark500,
    'surface-inverse': colors.silver.light900,
    'surface-elevated': colors.gray.light0,
    'status-warning-surface': colors.yellow.light600,
    'status-warning-line': colors.yellow.light500,
    'status-warning-fill-hover': colors.yellow.light200,
    'status-warning-fill': colors.yellow.light50,
    'status-warning-content': colors.yellow.light900,
    'status-success-surface': colors.green.light600,
    'status-success-line': colors.green.light500,
    'status-success-fill-hover': colors.green.light200,
    'status-success-fill': colors.green.light50,
    'status-success-content': colors.green.light900,
    'status-progress-surface': colors.sky.light600,
    'status-progress-line': colors.sky.light500,
    'status-progress-fill-hover': colors.sky.light200,
    'status-progress-fill': colors.sky.light50,
    'status-progress-content': colors.sky.light900,
    'status-info-surface': colors.silver.light600,
    'status-info-line': colors.silver.light500,
    'status-info-fill-hover': colors.silver.light200,
    'status-info-fill': colors.silver.light50,
    'status-info-content': colors.silver.light900,
    'status-indication-surface': colors.red.light700,
    'status-indication-line': colors.red.light700,
    'status-indication-fill-hover': colors.red.light200,
    'status-indication-fill': colors.red.light50,
    'status-indication-content': colors.red.light900,
    'status-danger-surface': colors.red.light700,
    'status-danger-line': colors.red.light700,
    'status-danger-fill-hover': colors.red.light200,
    'status-danger-fill': colors.red.light50,
    'status-danger-content': colors.red.light900,
    'page-primary': colors.silver.light10,
    'other-teal-surface': colors.teal.light600,
    'other-teal-line': colors.teal.light500,
    'other-teal-fill-hover': colors.teal.light200,
    'other-teal-fill': colors.teal.light50,
    'other-teal-content': colors.teal.light950,
    'other-purple-surface': colors.purple.light600,
    'other-purple-line': colors.purple.light500,
    'other-purple-fill-hover': colors.purple.light200,
    'other-purple-fill': colors.purple.light50,
    'other-purple-content': colors.purple.light950,
    'other-pink-surface': colors.pink.light600,
    'other-pink-line': colors.pink.light500,
    'other-pink-fill-hover': colors.pink.light200,
    'other-pink-fill': colors.pink.light50,
    'other-pink-content': colors.pink.light950,
    'other-lime-surface': colors.lime.light600,
    'other-lime-line': colors.lime.light500,
    'other-lime-fill-hover': colors.lime.light200,
    'other-lime-fill': colors.lime.light50,
    'other-lime-content': colors.lime.light950,
    'other-lemon-surface': colors.lemon.light600,
    'other-lemon-line': colors.lemon.light500,
    'other-lemon-fill-hover': colors.lemon.light200,
    'other-lemon-fill': colors.lemon.light50,
    'other-lemon-content': colors.lemon.light950,
    'other-indigo-surface': colors.indigo.light600,
    'other-indigo-line': colors.indigo.light500,
    'other-indigo-fill-hover': colors.indigo.light200,
    'other-indigo-fill': colors.indigo.light50,
    'other-indigo-content': colors.indigo.light950,
    'other-cyan-surface': colors.cyan.light600,
    'other-cyan-line': colors.cyan.light500,
    'other-cyan-fill-hover': colors.cyan.light200,
    'other-cyan-fill': colors.cyan.light50,
    'other-cyan-content': colors.cyan.light950,
    'other-chocolate-surface': colors.chocolate.light600,
    'other-chocolate-line': colors.chocolate.light500,
    'other-chocolate-fill-hover': colors.chocolate.light200,
    'other-chocolate-fill': colors.chocolate.light50,
    'other-chocolate-content': colors.chocolate.light950,
    'line-tertiary-hover': colors.silver.light300,
    'line-tertiary': colors.silver.light100,
    'line-selected-hover': colors.blue.light700,
    'line-selected': colors.blue.light500,
    'line-secondary-hover': colors.silver.light500,
    'line-secondary': colors.silver.light300,
    'line-primary-hover': colors.silver.light700,
    'line-primary': colors.silver.light500,
    'line-focus-outline': colors.blue.light200,
    'line-focus': colors.blue.light500,
    'line-elevated': colors.alpha.light0,
    'line-disable': colors.silver.light200,
    'fill-selected-hover': colors.blue.light700,
    'fill-selected': colors.blue.light500,
    'fill-secondary-hover': colors.silver.light100,
    'fill-secondary-active': colors.silver.light200,
    'fill-secondary': colors.silver.light50,
    'fill-primary-hover': colors.silver.light50,
    'fill-primary-active': colors.silver.light100,
    'fill-primary': colors.gray.light0,
    'fill-elevated': colors.gray.light0,
    'fill-disable': colors.silver.light50,
    'content-tertiary': colors.silver.light700,
    'content-secondary': colors.silver.light800,
    'content-primary': colors.silver.light950,
    'content-placeholder': colors.silver.light600,
    'content-on-dark': colors.gray.light0,
    'content-link-visited': colors.pink.light700,
    'content-link': colors.blue.light700,
    'content-inverse': colors.gray.light0,
    'content-disable': colors.silver.light500,
    'brand-secondary-hover': colors.sky.light100,
    'brand-secondary-border': colors.sky.light50,
    'brand-secondary-active': colors.sky.light200,
    'brand-secondary': colors.sky.light50,
    'brand-primary-hover': colors.sky.light600,
    'brand-primary-content': colors.sky.light900,
    'brand-primary-border': colors.sky.light700,
    'brand-primary-active': colors.sky.light500,
    'brand-primary': colors.sky.light700
  },
  variables: {
    'spacing-900': '4rem',
    'spacing-800': '3rem',
    'spacing-700': '2.5rem',
    'spacing-600': '2rem',
    'spacing-500': '1.5rem',
    'spacing-50': '0.125rem',
    'spacing-400': '1rem',
    'spacing-300': '0.75rem',
    'spacing-200': '0.5rem',
    'spacing-1100': '6rem',
    'spacing-1000': '5rem',
    'spacing-100': '0.25rem',
    'shadow-y-minus-400': '-0.5rem',
    'shadow-y-minus-300': '-0.375rem',
    'shadow-y-minus-200': '-0.25rem',
    'shadow-y-minus-100': '-0.125rem',
    'shadow-y-400': '0.5rem',
    'shadow-y-300': '0.375rem',
    'shadow-y-200': '0.25rem',
    'shadow-y-100': '0.125rem',
    'shadow-x-minus-400': '-0.5rem',
    'shadow-x-minus-300': '-0.375rem',
    'shadow-x-minus-200': '-0.25rem',
    'shadow-x-minus-100': '-0.125rem',
    'shadow-x-400': '0.5rem',
    'shadow-x-300': '0.375rem',
    'shadow-x-200': '0.25rem',
    'shadow-x-100': '0.125rem',
    'shadow-blur-400': '0.75rem',
    'shadow-blur-300': '0.5rem',
    'shadow-blur-200': '0.25rem',
    'shadow-blur-100': '0.125rem',
    'font-weight-regular': 400,
    'font-weight-bold': 700,
    'font-size-900': '3.25rem',
    'font-size-800': '2.75rem',
    'font-size-700': '2.25rem',
    'font-size-600': '1.75rem',
    'font-size-500': '1.5rem',
    'font-size-50': '0.625rem',
    'font-size-400': '1.25rem',
    'font-size-300': '1rem',
    'font-size-200': '0.875rem',
    'font-size-1100': '4.5rem',
    'font-size-1000': '3.75rem',
    'font-size-100': '0.75rem',
    'font-line-height-900': '4rem',
    'font-line-height-800': '3rem',
    'font-line-height-700': '2.5rem',
    'font-line-height-600': '2rem',
    'font-line-height-500': '1.75rem',
    'font-line-height-50': '0.75rem',
    'font-line-height-400': '1.5rem',
    'font-line-height-300': '1.25rem',
    'font-line-height-200': '1rem',
    'font-line-height-1100': '5.5rem',
    'font-line-height-1000': '4.5rem',
    'font-line-height-100': '0.875rem',
    'font-letter-spacing-500': '0.0625rem',
    'font-family': 'Arial',
    'border-radius-300': '0.5rem',
    'border-radius-200': '0.25rem',
    'border-radius-100': '0.125rem',
    'border-200': '0.125rem',
    'border-100': '0.0625rem',
    'base-unit': '16px'
  }
};
